import { GameResultStatus } from "../types";

const GameResults = ({
  className = "",
  gameResultStatus,
  resetGame,
  successTitle = "Great timing!",
  failureTitle = "Try Again",
  successMessage,
  failureMessage,
}: {
  className?: string;
  gameResultStatus: GameResultStatus;
  successMessage?: string;
  failureMessage?: string;
  successTitle?: string;
  failureTitle?: string;
  resetGame: () => void;
}) => {
  return (
    <div
      className={`fixed inset-0 z-[90] bg-black/70 backdrop-blur-sm flex items-center justify-center ${className}`}
    >
      <div className="rounded-2xl p-8 md:p-10 bg-neutral-900/70 border border-white/10 shadow-2xl text-center">
        <div
          className={`text-5xl md:text-7xl font-extrabold tracking-tight ${
            gameResultStatus === "success" ? "text-green-400" : "text-red-400"
          }`}
        >
          {gameResultStatus === "success" ? successTitle : failureTitle}
        </div>

        <div
          className={`mt-6 ${
            gameResultStatus === "success"
              ? "text-green-300/90"
              : "text-red-300/90"
          }`}
        >
          {gameResultStatus === "success" ? successMessage : failureMessage}
        </div>

        {gameResultStatus === "failure" && (
          <button
            onClick={resetGame}
            className="mt-6 px-6 py-3 rounded-2xl bg-white text-neutral-900 font-semibold hover:bg-white/90 active:scale-[0.98] transition"
          >
            Try again
          </button>
        )}
      </div>
    </div>
  );
};

export default GameResults;
